<template>
  <footer class="lg-aa-layout__rodape">
    <div class="lg-aa-layout__rodape__logo" />
    <div class="lg-aa-layout__rodape__copyright">
      {{ copyright }}
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LgRodape',
  data() {
    return {
      copyright: '',
    };
  },
  mounted() {
    const labelRodape = this.$t_v2('43986', 'Copyright © {0} LG lugar de gente - Todos os direitos reservados');

    this.copyright = labelRodape.replace('{0}', new Date().getFullYear());
  },
};
</script>

<style lang="scss" scoped>
.lg-aa-layout__rodape__copyright::before {
  content: "" !important;
}
</style>
